// Configuration centralisée des URLs backend.
// Les composants peuvent importer API_URL / ORGA_URL / ORGA_SITE_URL d'ici
// plutôt que de redéclarer `process.env.REACT_APP_* || 'http://localhost...'`.
//
// Garde-fou prod : en build de production, une variable manquante ferait
// silencieusement pointer l'app sur localhost (= cassée). On échoue alors
// bruyamment plutôt que de livrer une app qui tape sur localhost.

const isProd = process.env.NODE_ENV === 'production';

function resolve(name, devFallback, { required = true } = {}) {
  const value = process.env[name];
  if (value) return value;
  // En prod, seules les variables critiques échouent bruyamment plutôt que de
  // pointer silencieusement sur localhost. Les URLs organisateur sont optionnelles
  // (le site organisateur peut ne pas être déployé) → fallback toléré.
  if (isProd && required) {
    throw new Error(
      `[config] ${name} n'est pas définie. En production, configurez cette ` +
      `variable d'environnement au build (ex. réglages Netlify) — pas de ` +
      `fallback localhost en prod.`
    );
  }
  return devFallback;
}

export const API_URL = resolve('REACT_APP_API_URL', 'http://localhost:5000');
export const ORGA_URL = resolve('REACT_APP_ORGANIZER_API_URL', 'http://localhost:5001', { required: false });
export const ORGA_SITE_URL = resolve('REACT_APP_ORGANIZER_SITE_URL', 'http://localhost:3001', { required: false });
